import MUIBreadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import uniqueId from 'lodash/uniqueId'
import { Link as RouterLink } from 'react-router-dom'

import { Crumbs } from '#/components/PageHeader'

type Props = {
  crumbs: Crumbs[]
}

export default function Breadcrumbs({ crumbs = [] }: Props) {
  const last = crumbs.length - 1

  return (
    <MUIBreadcrumbs
      aria-label="breadcrumb"
      data-breadcrumb={crumbs?.map(c => c.name)?.join(' / ')}
      sx={{
        '& li': {
          maxWidth: '25ch',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      }}
    >
      {crumbs.map((crumb, i) => {
        if (!crumb.name) return null
        return i === last || !crumb.link ? (
          <Typography variant="caption" key={`crumbs-${i}`} color="secondary">
            {crumb.name}
          </Typography>
        ) : (
          <Link
            key={uniqueId('crumbs')}
            to={crumb.link}
            underline="none"
            className={'crumb-link'}
            variant="caption"
            component={RouterLink}
          >
            {crumb.name}
          </Link>
        )
      })}
    </MUIBreadcrumbs>
  )
}
